import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import {
    DataAuthorizationModel,
    SystemComponent,
} from '../insight/config.insight.model';
import { Tab } from '../insight/experimental.tabset';
import { TabType } from '../insight/tabset.model';

enum Step {
    TAB_TYPE,
    WIZARD,
}

@Component({
    selector: '[cmpsInsightExplorerWizard]',
    templateUrl: './wizard.ie.component.html',
    host: {
        class: 'cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300',
    },
})
export class WizardInsightExplorerComponent implements OnDestroy {
    Step = Step;
    TabType = TabType;
    currentStep: Step;
    selectedTabType: TabType;

    // eslint-disable-next-line accessor-pairs
    @Input()
    set permissions(value: DataAuthorizationModel[]) {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const valid =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            value &&
            value.filter(
                (e) =>
                    (e.componentId === SystemComponent.HUMAN_INSIGHT ||
                        e.componentId ===
                            SystemComponent.PERFORMANCE_INSIGHT) &&
                    e.granted === 1,
            );
        // only two options are available, if there's only permission for one, skip selection
        if (valid && valid.length === 1) {
            this.currentStep = Step.WIZARD;
            this.selectedTabType =
                valid[0].componentId === SystemComponent.HUMAN_INSIGHT
                    ? TabType.HUMAN
                    : TabType.PERFORMANCE;
        }
    }

    @Output()
    selectUser: EventEmitter<void>;

    @Output()
    tabCreate: EventEmitter<Tab>;

    constructor() {
        this.currentStep = Step.TAB_TYPE;
        this.selectUser = new EventEmitter();
        this.tabCreate = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.selectUser.complete();
        this.tabCreate.complete();
    }
}
